import { useEffect, useState } from 'react'
import './Banner.scss'
import Slider from "react-slick"
import { Baseurl } from '../../constants/env'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import altTexts from '../common/imgalttext/altTexts'
const Banner = () => {
  const [bannerdata, setBannerdata] = useState([])
  const init = async () => {
    let result = await axios.get(`${Baseurl}/banner`).catch(error => console.log(error,'error'))
    setBannerdata(result?.data)
    let resul = await axios(`${Baseurl}/category`).catch(error => console.log(error,'error'))
    setCategory(resul?.data?.data)
  }
  const settings = {
    dots: true,
    infinite: true ,
    speed: 500,
    slidesToShow: 1 || 0, 
    slidesToScroll: 1,
    arrows: true, 
    autoplay: true, 
    autoplaySpeed: 3000,
    responsive: [ 
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1 || 0,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1 || 0,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1 || 0,
          slidesToScroll: 1,
        },
      },
    ]
  }
  const [showCategory, setShowCategory] = useState(true)
  const [mobilemenu, setMobilemenu] = useState(false)
  const handleSearch = async (id) => {
    setShowCategory(false)
    if(mobilemenu)setMobilemenu(!mobilemenu)
    await navigate(`/Shop?category=${id}`)
  }
  const navigate = useNavigate()
  const [category , setCategory] =  useState([])
  useEffect(() => {
    (async () => {
    await init()
    })()
  },[])
  const fallbackAlt = 'Imox Kitchen Equipment'
  return (
    <>
    <section className="section-banner">
      <div class="container">
        <div className='row'>
          <div className='col-sm-3 categclass'>
            <div className= {`category-drop-down  ${showCategory ? 'w-25' : 'd-none'}`}>
              {
                category?.map((item,index) => (
                  <div onClick={() => handleSearch(item._id) } key={index} className="text-start  drop-categories">
                  <span className="pe-2"><img style={{width:'20px', height:'20px'}} src={`${Baseurl}/view/imageupload/${item.img}`} loading='lazy' alt={`${item?.name} in uae`} /></span> 
                  <button> {item?.name} </button> </div>
                ))
              }
            </div>
          </div>
          <div className='col-sm-9'><div>
          <Slider {...settings}>
            {bannerdata?.map((item, index) =>{ 
              const altTextIndex = index % altTexts.length;
              const altText = altTexts[altTextIndex] || fallbackAlt;
            return(
              <div className="banner-box-new" key={index}>
                  <div>
                    <img
                      src={`${Baseurl}/view/imageupload/${item?.img}`}
                      className="img-fluid"
                      loading='lazy'
                      alt={altText} 
                    />
                  </div>
              </div>
            )})}
          </Slider>
          </div>
        </div>
        </div>
      </div>   
    </section>
    </>
  )
}
export default Banner